export const STORAGE_KEY = 'covida.ch';